import React from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import Moment from 'moment-timezone'
import { getSite } from '../../actions/SiteActions'
import { updateDataViewConfigHash } from '../../actions/DataViewActions'
import { setAddManualInputFormVisibility, setDataViewSummary, fetchDataViewHash } from '../../actions/DataViewActions'
import { createManualInputRecord } from '../../actions/ManualInputActions'
import { createAnalyticsItemView } from '../../actions/AnalyticsItemViewActions'
import SiteContainer from '../../components/layout/SiteContainer'
import HelmetTitle from '../../components/layout/HelmetTitle'
import ContainerHeading from '../../components/layout/ContainerHeading'
import LoadingScreen from '../../components/LoadingScreen'
import Graph from '../../components/dataViews/Graph'
import Gauge from '../../components/dataViews/Gauge'
import DataTable from '../../components/dataViews/DataTable'
import DataRetrievalsTable from '../../components/dataViews/DataRetrievalsTable'
import AddManualInputForm from '../../components/dataViews/AddManualInputForm'
import ArrowRightBoldCircle from '../../components/icons/ArrowRightBoldCircle'
import ChartLine from '../../components/icons/ChartLine'
import Table from '../../components/icons/Table'
import { H1, GridContainer, GridSection, Column, ListRow, ColumnStyle, ColumnResponsiveInnerContainer, DataViewIconContainer, ActionColumnStyleRightAligned, ActionIconContainer } from './styled-elements'

class Site extends React.Component {

  constructor(props) {
    super(props)
    const { params } = props.match
    this.state = {
      graphOptions: {}
    }
    this.graphComponent = React.createRef()
  }

  componentDidMount() {
    const { dispatch, match } = this.props
    const companySlug = match.params.company_slug
    const siteSlug = match.params.site_slug
    const dataViewSlug = match.params.data_view_slug
    dispatch(getSite(companySlug,siteSlug))
    if (dataViewSlug) dispatch(fetchDataViewHash(companySlug,siteSlug,dataViewSlug))
    if (match.url.match(/gauge$/)) {
      console.log("XXXXX match")
    }
  }

  componentDidUpdate(prevProps,prevState,snapshot) {
    const { dispatch, match } = this.props
    const companySlug = match.params.company_slug
    const siteSlug = match.params.site_slug
    const dataViewSlug = match.params.data_view_slug
    const prevDataViewSlug = prevProps.match.params.data_view_slug
    const prevSite = prevProps.sites.site
    const currentSite = this.props.sites.site
    if (currentSite && currentSite.data_views && dataViewSlug && (dataViewSlug!=prevDataViewSlug)) {
      dispatch(fetchDataViewHash(companySlug,siteSlug,dataViewSlug))
      const dataView = currentSite.data_views.find(dv => dv.slug===dataViewSlug)
      dispatch(createAnalyticsItemView('data_view',dataView.data_view_id))
    }
    if ((!prevSite || !Object.keys(prevSite).length) && (currentSite && Object.keys(currentSite).length && currentSite.data_views)) {
      const dataViewSummary = currentSite.data_views.find(o => o.slug===dataViewSlug)
      dispatch(setDataViewSummary(dataViewSummary))
      dispatch(createAnalyticsItemView('site',currentSite.id))
    }
  }

  routeToView = (dv) => {
    this.props.dispatch(push(`${this.props.match.url}/data_views/${dv.slug}`))
  }

  routeToConfig = () => {
    this.props.dispatch(push(`${this.props.match.url}/configure`))
  }

  getDataViewIcon = (dv) => {
    return <DataViewIconContainer>
      {(dv.data_view_type_category==='graph') && <ChartLine />}
      {(dv.data_view_type_category==='table') && <Table />}
    </DataViewIconContainer>
  }

  renderDataViewsRows(dataViews) {
    console.log("XXX dataViews",dataViews)
    return dataViews.sort((a,b) => a.sort_order-b.sort_order).map((dv,index) => <ListRow divisions={12} key={index} onClick={this.routeToView.bind(this,dv)}>
      <Column xs={10} style={ColumnStyle}><ColumnResponsiveInnerContainer>{this.getDataViewIcon(dv)}{dv.name}</ColumnResponsiveInnerContainer></Column>
      <Column xs={2} style={ActionColumnStyleRightAligned}><ActionIconContainer onClick={this.routeToView.bind(this,dv)}><ArrowRightBoldCircle right /></ActionIconContainer></Column>
    </ListRow>)
  }

  renderManageRows(site) {
    return (<ListRow divisions={12} key={0} onClick={this.routeToConfig}>
      <Column xs={10} style={ColumnStyle}><ColumnResponsiveInnerContainer>Config</ColumnResponsiveInnerContainer></Column>
      <Column xs={2} style={ActionColumnStyleRightAligned}><ActionIconContainer><ArrowRightBoldCircle right /></ActionIconContainer></Column>
    </ListRow>)
  }

  renderSiteDataViews(site,user) {
    if (site && site.data_views) {
      return <div>
        <H1>{site.name}</H1>
        <GridContainer>
          <ContainerHeading title={`View Data`} />
          <GridSection>
            {this.renderDataViewsRows(site.data_views)}
          </GridSection>
        </GridContainer>
        { (user.company_slug==="tain-electronics") &&
          <GridContainer>
            <ContainerHeading title={`Manage`} />
            <GridSection>
              {this.renderManageRows(site)}
            </GridSection>
          </GridContainer>
        }
      </div>
    }
  }

  updateDataViewConfigHash = (updateHash) => {
    const { dispatch, match } = this.props
    const { params } = match
    const companySlug = params.company_slug
    const siteSlug = params.site_slug
    const dataViewSlug = params.data_view_slug
    dispatch(updateDataViewConfigHash(companySlug,siteSlug,dataViewSlug,updateHash))
  }

  renderShowDataView(props,state) {
    const site = props.sites.site
    const { dispatch } = props
    if (!site || !site.id) return null
    const dataViews=site.data_views
    const dataViewSlug = this.props.match.params.data_view_slug
    const dataView = dataViews.find(dv => dv.slug===dataViewSlug)
    const includeGraphActions = (site.manual_inputs.length > 0)
    let options
    //console.log('dataView.data_view_type_category',dataView.data_view_type_category)
    if (dataView) {
      switch (dataView.data_view_type_category) {
        case 'graph':
          if (props.dataViews.dataViewHash && props.dataViews.dataViewHash.chart) {
            options = props.dataViews.dataViewHash
            return <Graph
              closeDataViewHandler={this.dataViewCloseDataViewHandler}
              dispatch={dispatch}
              site={site}
              dataView={dataView}
              options={options}
              manualInputs={site.manual_inputs}
              manualInputs={site.manual_inputs}
              dataViewSummary={props.dataViews}
              manualInputFormOpenHandler={this.manualInputFormOpenHandler}
              manualInputFormCloseHandler={this.manualInputFormCloseHandler}
              includeGraphActions={includeGraphActions}
              updateDataViewConfigHashHandler={this.updateDataViewConfigHash}
              ref={this.graphComponent}
            />
          }
          break
        case 'gauge':
          if (props.dataViews.dataViewHash && props.dataViews.dataViewHash.chart) {
            options = props.dataViews.dataViewHash
            return <Gauge
              closeDataViewHandler={this.dataViewCloseDataViewHandler}
              dispatch={dispatch}
              site={site}
              dataView={dataView}
              options={options}
              dataViewSummary={props.dataViews}
              updateDataViewConfigHashHandler={this.updateDataViewConfigHash}
              ref={this.graphComponent}
            />
          }
          break
        case 'table':
          if (dataView.data_view_type_key==="table_retrieve_data_events") return <DataRetrievalsTable closeDataViewHandler={this.dataViewCloseDataViewHandler} dispatch={dispatch} site={site} dataView={dataView} data={props.dataViews.dataViewHash} downloadAsClickHandler={this.downloadAsClickHandler} />
          if (dataView.data_view_type_key==="table_all_sensors") return <DataTable closeDataViewHandler={this.dataViewCloseDataViewHandler} dispatch={dispatch} site={site} dataView={dataView} data={props.dataViews.dataViewHash} downloadAsClickHandler={this.downloadAsClickHandler} />
          break
        //default:
        //  return null
      }
    }
  }

  manualInputFormOpenHandler = () => {
    this.props.dispatch(setAddManualInputFormVisibility(true))
  }

  manualInputFormCloseHandler = () => {
    this.props.dispatch(setAddManualInputFormVisibility(false))
  }

  manualInputFormSubmitHandler = (params) => {
    const { dispatch, match } = this.props
    const site = this.props.sites.site
    const manualInputs = site.manual_inputs
    const selectedManualInput = manualInputs.find((o) => o.id===params.manual_input_id)
    const seriesId = selectedManualInput.series_id
    const valueType = params.value_type
    const value = parseFloat(params.value)
    const comment = params.comment
    const date = params.date
    const timezone = this.props.sites.site.timezone_name
    const timeStamp = parseFloat(Moment.tz(date,timezone).format('x'))
    let dataPoint
    if (valueType==="text") {
      dataPoint = {'x': timeStamp, 'title': comment}
    } else if (valueType==="numeric") {
      dataPoint = [timeStamp, value]
    }
    this.graphComponent.current.addDataPoint(seriesId,dataPoint)
    dispatch(setAddManualInputFormVisibility(false))
    const companySlug = match.params.company_slug
    const siteSlug = match.params.site_slug
    const manualInputId = params.manual_input_id
    delete params['manual_input_id']
    dispatch(createManualInputRecord(companySlug,siteSlug,manualInputId,params))
  }

  downloadAsClickHandler = (format) => {
    const { dispatch, match } = this.props
    if (!this.props.apiAuth.isSignedIn) return dispatch(push('/logout'))
    const companySlug = match.params.company_slug
    const siteSlug = match.params.site_slug
    const dataViewSlug = match.params.data_view_slug
    axios.get(`companies/${companySlug}/sites/${siteSlug}/data_views/${dataViewSlug}/data_view_hash.${format}`,
    {
      responseType: 'blob'
    })
    .then((response) => {
      const contentDisposition = response.headers['content-disposition']
      const fileName = contentDisposition.match(/filename=(.*)$/)[1]
      const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.headers['content-type']});
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    })
  }

  getLoadingScreenState() {
    const { apiAuth, sites, dataViews } = this.props
    return (
      apiAuth.validating ||
      sites.fetching ||
      dataViews.fetching
    )
  }

  dataViewCloseDataViewHandler = () => {
    const companySlug = this.props.sites.site.company_slug
    const siteSlug = this.props.sites.site.slug
    this.props.history.replace(`/sites/${companySlug}/${siteSlug}`)
  }

  renderBody = (props,state) => {
    return <div>
      <LoadingScreen show={this.getLoadingScreenState()}/>
      <AddManualInputForm
        open={this.props.dataViews.addManualInputFormVisible}
        manualInputs={(props.sites.site && props.sites.site.manual_inputs) || []}
        timezone={(props.sites.site && props.sites.site.timezone_name) || ''}
        closeHandler={this.manualInputFormCloseHandler}
        submitHandler={this.manualInputFormSubmitHandler}
      />
      { props.match.params.data_view_slug && props.dataViews && this.renderShowDataView(props,state) }
      { props.match.url.match(/gauge$/) && this.renderShowDataView(props,state) }
      { props.sites.site && this.renderSiteDataViews(props.sites.site,props.apiAuth.user) }
    </div>
  }

  render = () => <SiteContainer isSignedIn={this.props.apiAuth.isSignedIn}>
    <HelmetTitle title={`${this.props.sites.site && this.props.sites.site.name} – Data Views`} />
    { this.renderBody(this.props,this.state) }
  </SiteContainer>

}

export default connect(
  (store, props) => ({
    apiAuth: store.apiAuth,
    sites: store.sites,
    dataViews: store.dataViews,
    routing: store.routing,
  }),
)(Site)



// WEBPACK FOOTER //
// ./src/containers/sites/site.js